module.exports = __webpack_public_path__ + "static/media/non-resident-user.5c05bc5e.svg";